var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.721 0H11.8045C2.3462 0 -0.00585938 2.52721 -0.00585938 12.611V40.7857C-0.00585938 47.4415 3.64734 49.0179 8.07621 44.2637L8.10123 44.2387C10.153 42.0618 13.2808 42.237 15.0573 44.614L17.5845 47.992C19.6113 50.6693 22.8892 50.6693 24.9159 47.992L27.4432 44.614C29.2447 42.2119 32.3725 42.0368 34.4243 44.2387C38.8782 48.9929 42.5063 47.4165 42.5063 40.7607V12.611C42.5314 2.52721 40.1793 0 30.721 0ZM28.1438 21.8942H14.3817C13.3558 21.8942 12.5051 21.0434 12.5051 20.0175C12.5051 18.9916 13.3558 18.1409 14.3817 18.1409H28.1438C29.1697 18.1409 30.0204 18.9916 30.0204 20.0175C30.0204 21.0434 29.1697 21.8942 28.1438 21.8942Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.7d2efe906cd798be594a863c8ad01e2b.svg";
export { ForwardRef as ReactComponent };